import { setBaseUrl, useMiddleware } from '@foundatiofx/fetchclient';
import { error, redirect } from '@sveltejs/kit';
import { getTabClientId } from '#lib/utils/tabClientId.ts';
import { gotoLogin, loginRedirectTarget, sessionIsAlive } from '#api/auth.ts';
import { tabRequestBudget } from '#api/requestBudget.ts';

useMiddleware(tabRequestBudget(300, 60));

useMiddleware(async (ctx, next) => {
    const tabClientId = getTabClientId();
    if (tabClientId != null && !ctx.request.headers.has('ClientId')) {
        ctx.request.headers.set('ClientId', String(tabClientId));
    }
    await next();
});

const forbidden = 'You do not have permission to view this';

useMiddleware(async (ctx, next) => {
    await next();

    if (ctx.response?.status === 401 && !ctx.options.expectedStatusCodes?.includes(401)) {
        // A thrown redirect is honored by SvelteKit when the 401 originates inside a `load`
        // function; gotoLogin() covers fetches made outside load (event handlers, effects).
        // Both no-op on (auth)/(open) routes, so the login page itself can't redirect-loop.
        const target = await loginRedirectTarget();

        // An endpoint can refuse an authenticated caller with a 401, so the status alone is not
        // proof the session ended — and a logged-in user must never be sent to the login page.
        if (target && !(await sessionIsAlive())) {
            await gotoLogin();
            throw redirect(303, target);
        }

        if (target) {
            throw error(403, forbidden);
        }
    }

    // Without this, a 403 thrown from a load function renders as a generic 500 error page.
    if (ctx.response?.status === 403 && !ctx.options.expectedStatusCodes?.includes(403)) {
        throw error(403, forbidden);
    }

    if (ctx.response?.status === 404 && !ctx.options.expectedStatusCodes?.includes(404)) {
        throw error(404, 'Not found');
    }
});

setBaseUrl('api');
